import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../../../../core/config.service';
import { RequestResult } from '../../models';
import { Token } from '../../models/authentication/token';
import { BaseRestApiService } from '../base/base-rest.api.service';
import { LogService } from '../logging/log.service';

@Injectable()
export class AuthenticationApiService extends BaseRestApiService {
    constructor(http: HttpClient, logService: LogService, private configService: ConfigService) {
        super(http, logService);
    }

    login(email: string, password: string): Observable<RequestResult<Token | string>> {
        const encodedEmail: string = encodeURIComponent(email);
        const encodedPassword: string = encodeURIComponent(password);
        const headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'no-auth': 'true' });
        const body: any = `client_id=${this.configService.getEnv('oauthClientId')}&grant_type=password&username=${encodedEmail}&password=${encodedPassword}`;
        return this.post(this.configService.getEnv('accountApi') + '/token', body, headers);
    }

    refresh(refreshToken: string): Observable<RequestResult<Token | string>> {
        const headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'no-auth': 'true' });
        const body: any = `client_id=${this.configService.getEnv('oauthClientId')}&grant_type=refresh_token&refresh_token=${refreshToken}`;
        return this.post(`${this.configService.getEnv('accountApi')}/token`, body, headers);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/authentication/authentication.api.service.ts